import { useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

const MIN_INTERVAL_MS = 2 * 60 * 1000;

/**
 * Okresowo ustawia public.users.last_seen_at dla zalogowanego użytkownika.
 * Wyłącz (`enabled: false`), gdy użytkownik ma włączone „Ukryj status ostatniej aktywności”
 * — wtedy nie aktualizujemy znacznika w bazie.
 *
 * @param {boolean} enabled — aktywne konto, znane ustawienia prywatności i brak ukrycia aktywności.
 */
export function useLastSeenHeartbeat(enabled) {
  const lastPingRef = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    const ping = async () => {
      const t = Date.now();
      if (t - lastPingRef.current < MIN_INTERVAL_MS - 4000) return;
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || cancelled) return;
      lastPingRef.current = t;
      const { error } = await supabase
        .from('users')
        .update({ last_seen_at: new Date().toISOString() })
        .eq('id', user.id);
      if (error) {
        console.warn('last_seen_at update:', error.message || error);
      }
    };

    void ping();
    const intervalId = window.setInterval(() => void ping(), MIN_INTERVAL_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') void ping();
    };
    const onFocus = () => void ping();

    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onFocus);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled]);
}
